module.exports = __webpack_public_path__ + "img/logo_DigicardSinSistemas.237ce291.png";